import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss'],
})
export class ThemeToggleComponent  implements OnInit {
  @Output() themeSelected = new EventEmitter<string>();
  constructor(private localStorageService: StorageService) { }

  currentTheme = 'dark';
  async ngOnInit() {
    const isDarkMode = await this.localStorageService.get('data-theme');
    if(isDarkMode)
    {
      this.currentTheme = isDarkMode;
      this.themeSelected.emit(isDarkMode);
    }
      
  }

  async toggleTheme() {
    const nextValue = this.currentTheme == 'dark' ? 'blue' : 'dark';
    document.body.setAttribute('data-theme', nextValue);
    this.currentTheme = nextValue;
    this.localStorageService.set('data-theme', nextValue);
    this.themeSelected.emit(nextValue);
  }
}
